import React, { useContext } from "react";

import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import SearchContext from "@/context/SearchContext";
import { CategoryMap } from "@/types/search";
import { cn } from "@/utils/general";

import styles from "./Categories.module.scss";
import ProductList from "./ProductList";
import { getFilteredCategories, sortProducts } from "./utils";

export interface CategoriesProps {
  categories: CategoryMap;
}

// ------------------- Component -------------------

const Categories: React.FC<CategoriesProps> = ({ categories }) => {
  const { subscriptionsAndOrders } = useContext(SearchContext);

  const filteredCategories = getFilteredCategories(categories, subscriptionsAndOrders);
  const purchasedSkus = Object.values(subscriptionsAndOrders).flat() as string[];

  return (
    <div className={cn("flex flex-col", styles.subtitleImages)}>
      {filteredCategories.map(([title, products], index) => {
        const sortedProducts = sortProducts(products, purchasedSkus).slice(0, 4);

        return (
          <div
            key={title}
            className={cn(
              index === 0 ? styles.mb1 : styles.mb4,
              styles.wFullPlus16,
              styles.wFullSm
            )}
          >
            <TextElement
              className={cn(
                "body--regular text-master-base-alt-alt pb-[5px] md:pb-[4px]",
                styles.categoryFont
              )}
            >
              {title}
            </TextElement>
            <ProductList products={sortedProducts} />
          </div>
        );
      })}
    </div>
  );
};

export default Categories;
